module.exports = __webpack_public_path__ + "img/illustrationundraw_voice_interface_eckp.dd3450f2.svg";